import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function ResearchAreaEdit(props) {
  const { updateTable, setUpdateTable, researchArea } = props;
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [researchAreaName, setResearchAreaName] = useState(researchArea.tagName);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    // Set the fields back to the researchArea's data
    setResearchAreaName(researchArea.tagName);
  }, [researchArea, openEditDialog]);

  const handleEditResearchArea = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("tagId", researchArea.tagId);
    body.append("researchAreaName", researchAreaName);
    axios.post("/faculty/editResearchArea", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setResearchAreaName("");
  };

  function showEditDialog() {
    return (
      <Dialog open={openEditDialog} maxWidth={false}>
        <DialogTitle className="ResearchAreaEdit-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Edit Research Area
        </DialogTitle>
        <div className="ResearchAreaEdit-modalContainer flex flex-col w-fit mb-4">
          <div className="ResearchAreaEdit-researchAreaContainer flex flex-col w-96 mx-auto mb-2">
            <div className="ResearchAreaEdit-researchArea text-lg font-brand-primary">
              Research Area *
            </div>
            <CreateValidateTextField
              placeholder="Quantum Computing"
              pattern="(?=.*\w).+"
              value={researchAreaName}
              setter={setResearchAreaName}
              errorMessage={"Invalid Research Area."}
              required={true}
            />
          </div>
          <div className="ResearchAreaEdit-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleEditResearchArea}
            >
              Update Research Area
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenEditDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="ResearchAreaEdit-container">
      {showEditDialog()}
      <button className="flex mr-4" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

ResearchAreaEdit.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  researchArea: PropTypes.shape({
    tagId: PropTypes.number,
    tagName: PropTypes.number,
  }),
};

ResearchAreaEdit.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
  researchArea: {},
};

export default ResearchAreaEdit;
